import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CompanyService } from '../company.service';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { ToastService } from '../../shared/toast.service'
import { UnsavedmsgModalComponent } from '../../unsavedmsg-modal/unsavedmsg-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../app.service'
import { Router } from '@angular/router';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog.service';
import { Userdefinedservice, userdefinedParams } from '../../shared/userdefinedservice';
import { AdobelaunchService } from '../../_services/adobelaunch.service';
import { combineLatest } from 'rxjs';
import { isLockForValidationSelector, isPrfLocked } from '../premiumreport/data-access/premium-report.selectors';
import { Store } from '@ngrx/store';
import { ValidationSummaryService } from '../validation-summary/data-access/validation-summary-service';
import { updateLockStatus } from '../premiumreport/data-access/premium-report.action';
import { selectGroupCode, selectPrfName, selectPrfNumber, selectPrfYear } from 'src/app/store/selectors/app.selector';
@Component({
    selector: 'app-annualstatement',
    templateUrl: './annualstatement.component.html',
    styleUrls: ['./annualstatement.component.scss'],
    standalone: false
})
export class AnnualstatementComponent implements OnInit, AfterViewInit {

  compno: any;
  currentYear: number;
  prfNumber: string;
  prfName: string;
  annualStatement: any[] = [];
  isolines: any[] = [];
  annualStatementGroupMappingdetails: any;


  public direct_premium: any[];
  public supplemental_premium: any[];
  public userdefined_premium: any[];
  public udcolumns: any[];
  public userdefined_premium_supplemental: any[];
  public columns: any[];
  public rows: any[];
  public const_statecode_column = 2;
  public const_fixed_columns = 3;
  public userdefined_row_code = "UD";
  public supplemental_row_code = "SP";
  public AssumedFromNonAffiliates_row_code = "AN";
  userdefinedparams: userdefinedParams;


  selectedisoline: number;
  oldselectedisoline: number;
  anualstatementsForm: UntypedFormGroup;
  isolinesoaded: Promise<boolean>;
  anualstatementoaded: Promise<boolean>;
  unsavedData: boolean = false;
  show: boolean = true;
  spinnersave: boolean;
  hideornot: boolean = false;
  counter: number = 0;
  isComplete: boolean = false;
  isLocked: boolean;
  isReadOnly: boolean;
  isReadOnlyAdmin: boolean;
  isoline: any
  selectedLine: string
  pageError: boolean
  groupcode: any
  isolinerequired: boolean = false;
  saveResponseMsg: string = "";
  isolinerequiredfordirect: boolean = false;
  aggregateWriteins: boolean = false;
  isLockForValidation: boolean = false;
  constructor(
    private router: Router,
    private appService: AppService,
    public toastService: ToastService,
    private companyService: CompanyService,
    public builder: UntypedFormBuilder,
    private modalService: NgbModal,
    private confirmDialogService: ConfirmDialogService,
    private userdefinedservice: Userdefinedservice,
    private AdobelaunchService:AdobelaunchService,
    private store: Store,
    private validationSummaryService: ValidationSummaryService,
  ) {
    this.anualstatementsForm = this.builder.group({});

    // this.rowValidateForm(1);
  }
  ngAfterViewInit() {
    this.AdobelaunchService.EventEndDispatch();
    }
  rowValidateForm(i: number, scenario?: string) {

    this.anualstatementsForm.addControl('Text1_' + i, new UntypedFormControl(this.annualStatement[i].DisplayText));
    this.anualstatementsForm.addControl('Text_' + i, new UntypedFormControl(this.annualStatement[i].Text));
    this.anualstatementsForm.addControl('Col1_' + i, new UntypedFormControl(this.annualStatement[i].Col1, Validators.pattern("/^[0-9]*\.?[0-9]*$/g")));
    this.anualstatementsForm.addControl('Col2_' + i, new UntypedFormControl(this.annualStatement[i].Col2, Validators.pattern("/^[0-9]*\.?[0-9]*$/g")));
  }

  ngOnInit(): void {

    this.removePrevAlerts();
    this.companyService.annualstatementCompleted.subscribe(result => {
      this.isComplete = result;
    });
this.store.select(selectPrfName).subscribe(prfName => {
      this.prfName = prfName;
    });
 
    this.store.select(selectPrfNumber).subscribe(prfNumber => {
      this.prfNumber = prfNumber || '';
      this.compno = prfNumber || '';
    });

     this.store.select(selectPrfYear).subscribe(year => {
      this.currentYear = year;
    });
this.store.select(selectGroupCode).subscribe(groupCode => {
      this.groupcode = groupCode;
      if (!this.groupcode) {
        this.companyService.getgroup().subscribe((value) => {
          this.groupcode = value;
        });
      }
    });
    this.isLocked = this.companyService.isEditLocked;
    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;
    this.isReadOnly = this.isLocked || this.isReadOnlyAdmin;
    this.getAnualStatement();
    this.getPrgress();
    this.getIsoLines();

    combineLatest([
      this.store.select(isLockForValidationSelector),
      this.store.select(isPrfLocked),
    ]).subscribe(([isValidationLocked, prfLocked]) => {
      console.log(
        'updated',
        isValidationLocked,
        localStorage.getItem('isLocked') == 'true'
      );

      this.isLocked = prfLocked || isValidationLocked;
      this.isLockForValidation = isValidationLocked;
      this.isReadOnly = this.isLocked || this.appService.isReadonlyAdmin;
      console.log(this.isLocked);
    });
  }

  getPrgress() {

    this.companyService.getCustomerPrfProgress(this.currentYear, this.compno, this.groupcode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          if (!this.isComplete)
            this.companyService.groupreportingInProgress.next(true)
        }
      },
      error: (error) => {
        //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    });


  }
  getAnualStatement() {
    this.companyService.getAnualStatement(this.currentYear, this.compno).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          let mappingDetails = resp["data"]["mappingdetails"];
          this.annualStatement = mappingDetails;
          this.annualStatementGroupMappingdetails = resp["data"]["ASTMTGROUP"];
          for (var i = 0; i < this.annualStatement.length; i++) {
            if (this.annualStatement[i].Col1 == '0') {
              this.annualStatement[i].Col1 = '';
            }
            if (this.annualStatement[i].Col2 == '0') {
              this.annualStatement[i].Col2 = '';
            }
            this.rowValidateForm(i);
          }

          if (mappingDetails[this.annualStatement.length - 1]['Col1'] !== '') {
            const tot1 = parseFloat(mappingDetails[this.annualStatement.length - 1]['Col1']);
            this.annualStatement[this.annualStatement.length - 1].Col1 = tot1
          }
          if (mappingDetails[this.annualStatement.length - 1]['Col2'] !== '') {
            const tot2 = parseFloat(mappingDetails[this.annualStatement.length - 1]['Col2']);
            this.annualStatement[this.annualStatement.length - 1].Col2 = tot2
          }

          this.show = false;
          this.anualstatementoaded = Promise.resolve(true)
        }
      },
      error: (error) => {
        //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    })
  }

clickToUnLock(): void {
  const inputData = {
    prfuser: this.companyService.userid,
    year: this.currentYear,
    companyNumber: this.compno,
    groupCode: this.groupcode,
    dummyrpt: false
  };

  this.validationSummaryService.unlockToEdit(inputData).subscribe({
    next: (response: any) => {
      if (response) {
        this.toastService.show('PRF unlocked for editing successfully', {
          classname: 'bg-success text-light',
          delay: 3000
        });

        this.isLockForValidation = false;
        this.isLocked = false;
        this.isReadOnly = this.isReadOnlyAdmin;

        this.store.dispatch(updateLockStatus());
      }
    },
    error: (error) => {
      console.error('Error unlocking page:', error);
      this.router.navigate(['/apifailure']);
    }
  });
}

  is_aggwn_label(text){
    return text.trim().toLowerCase().replace(' ',"").replace('-',"")=='aggregatewriteins'
  }

  getIsoLines() {
    this.companyService.getIsoLines(this.currentYear, this.compno).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.isolines = resp["isolineslist"]["isolines"];
          this.selectedisoline = resp["isolineslist"]["selindex"];

          this.oldselectedisoline = this.selectedisoline;

          if (this.selectedisoline == 0) {
            this.appendSelectInIsoline();
          }
          this.isoline = this.isolines.filter(i => i.Number == this.selectedisoline)[0].Value

          this.selectedLine = this.isolines[0].Value;
        }
        this.isolinesoaded = Promise.resolve(true);
      },
      error: (error) => {
        //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    })
  }
  calculateDirect(e) {
    const input = e.target.value;
    if (input) {
      this.validateInput(e);
    }
    this.checkAggregatewritein();
    let total = 0;
    for (let i = 0; i < this.annualStatement.length - 1; i++) {
      const value = this.annualStatement[i].Col1;
      if (value == '-' || value == '.' || value == '' || value == 0 || /[^-?.0-9]+/g.test(value)) {
        this.annualStatement[i].Col1 = '';
        if (this.annualStatement[i].DisplayText === '34.') {
          this.isolinerequiredfordirect = false;
          this.pageError = false;
        }
      }
      else if (this.annualStatement[i].Col1 !== '' && this.annualStatement[i].Col1 !== null) {
        let prem = 0
        prem = parseInt(parseFloat(this.annualStatement[i].Col1).toFixed());
        this.annualStatement[i].Col1 = prem
        total = total + prem
        if (this.annualStatement[i].DisplayText === '34.') {
          this.isolinerequiredfordirect = true;
          this.pageError = false;
        }
      }
    }
    let roundTotal = total
    if (Object.is(roundTotal, -0)) {
      roundTotal = 0;
    }
    if ((this.annualStatement[this.annualStatement.length - 1].Col1 !== roundTotal) && !this.isReadOnly)
      this.unsavedData = true;
    this.annualStatement[this.annualStatement.length - 1].Col1 = roundTotal;
  }
  validateInput(e) {
    if (parseFloat(e.target.value) == 0 || /[^-?.0-9]+/g.test(e.target.value)) {
      e.target.value = '';
    }
  }
  calculateNonDirect(e) {
    var input = e.target.value;
    if (input) {
      if (parseFloat(input) == 0 || /[^-?.0-9]+/g.test(input)) {
        e.target.value = '';
      }
      // else {
      //   e.target.value = parseFloat(input).toFixed();
      // }

    }
    var total = 0;
    for (var i = 0; i < this.annualStatement.length - 1; i++) {
      var value = this.annualStatement[i].Col2;
      if (value == '-' || value == '.' || value == '' || value == 0 || /[^-?.0-9]+/g.test(value)) {
        this.annualStatement[i].Col2 = '';
        if (this.annualStatement[i].DisplayText === '34.') {
          this.isolinerequired = false;
          this.pageError = false;
        }
      }
      else if (this.annualStatement[i].Col2 !== '' && this.annualStatement[i].Col2 !== null) {
        var prem = 0
        prem = parseInt(parseFloat(this.annualStatement[i].Col2).toFixed());
        this.annualStatement[i].Col2 = prem
        total = total + prem //parseFloat(this.annualStatement[i].Col2)
        if (this.annualStatement[i].DisplayText === '34.') {
          this.isolinerequired = true;
          this.pageError = false;
        }
      }
    }
    var roundTotal = total
    if (Object.is(roundTotal, -0)) {
      roundTotal = 0;
    }
    if ((this.annualStatement[this.annualStatement.length - 1].Col2 !== roundTotal) && !this.isReadOnly)
      this.unsavedData = true;
    this.annualStatement[this.annualStatement.length - 1].Col2 = roundTotal;

  }

  numberOnly(e) {

    if (!this.isReadOnly)
      this.unsavedData = true;
  }
  hasUnsavedData() {
    return this.unsavedData;
  }
  validateDecimalInput(event): boolean {
    if (!this.isReadOnly)
      this.unsavedData = true;
    const charCode = (event.which) ? event.which : event.keyCode;
    var value = event.target.value;

    var cursorPosition = event.target.selectionStart;
    if (charCode == 46 && value.includes('.') || (charCode == 45 && cursorPosition != 0) || (charCode == 45 && value.includes('-') && cursorPosition == 0)) {
      return false;
    }
    // if (event.target.value.length == 1&& value.includes('0') && charCode == 48 ||  (value.includes('-') && charCode == 48 && (cursorPosition == 0 || cursorPosition == 1 ))) {
    //   return false;
    // }
    if ((charCode >= 48 && charCode <= 57) || (charCode > 44 && charCode < 47)) {
      if (value.includes('-') && cursorPosition === 0) {
        return false;
      }
      return true;
    }
    return false;
  }
  validateNumericInput(event): boolean {
    if (!this.isReadOnly)
      this.unsavedData = true;
    const charCode = (event.which) ? event.which : event.keyCode;
    var value = event.target.value;
    var cursorPosition = event.target.selectionStart;
    if ((charCode == 45 && cursorPosition != 0) || (charCode == 45 && value.includes('-') && cursorPosition == 0)) {
      return false;
    }
    if ((charCode >= 48 && charCode <= 57) || (charCode == 45)) {
      if (value.includes('-') && cursorPosition === 0) {
        return false;
      }
      return true;
    }
    return false;
  }
  onsubmit() {
    this.checkAggregatewritein();
    if (this.selectedLine === "Select" && (this.isolinerequired || this.isolinerequiredfordirect)) {
      this.pageError = true;
    } else if (this.aggregateWriteins) {
      this.confirmDialogService.confirmThis(
        'Annual Statement',
        'You have selected ISO Line but have not entered a value in Aggregate Write-ins. Click "<b>Yes</b>" to clear the ISO Line mapping and Aggregate Write-ins User Defined data, or click "<b>No</b>" to go back and enter a value',
        () => {
          this.aggregateWriteins = false;
          this.selectedisoline = 0;
          this.appendSelectInIsoline();
          this.selectedLine = "Select";
          this.saveAnnualStatement();
        },
        () => {
          this.aggregateWriteins = false;
          console.log('no');
        }
      );
    }
    else{
      this.saveAnnualStatement();
    }
  }

  private checkAggregatewritein() {
    for (let i = 0; i < this.annualStatement.length - 1; i++) {
      if (this.annualStatement[i].DisplayText === '34.') {
        if (this.annualStatement[i].Col1 == '' && this.annualStatement[i].Col2 == '' && this.selectedisoline != 0) {
          this.aggregateWriteins = true;
          return;
        }
      }
    }
  }
private appendSelectInIsoline(){
  if (!this.isolines.some(isoline => isoline.Value === 'Select')) {
    this.isolines.unshift({ Number: 0, Value: 'Select' });
    }
}
private saveAnnualStatement() {
  let isolinenumber = this.selectedisoline == 0 ? '' : this.selectedisoline
  this.companyService.disableCompanyList.next(true)
  this.companyService.clearStatus();
  this.toastService.remove(this.toastService.toasts[0]);
  this.spinnersave = true;
  this.annualStatement = Object.assign(this.annualStatement, this.anualstatementsForm.value);
  let asmtDetails = {"ASTMTCELL": this.annualStatement,"ASTMTGROUP": this.annualStatementGroupMappingdetails};
  this.companyService.saveAnualStatement(this.currentYear, this.compno, asmtDetails, isolinenumber, this.groupcode).subscribe({
    next: (resp) => {
      if (resp["message"] == "Success") {
        this.saveResponseMsg = resp["data"];
        this.companyService.getPremiumReportData(this.compno, this.currentYear, this.groupcode).subscribe({
          next: (resp) => {
            if (resp["message"] == "Success") {
              const result = resp['data'];
              this.direct_premium = resp['data']['data']['direct_premium'];
              this.supplemental_premium = resp['data']['data']['supplemental_premium'];
              this.userdefined_premium = resp['data']['userdefined_premium']['dpremium'];
              this.userdefined_premium_supplemental = resp['data']['userdefined_premium']['spremium'];
              this.columns = result["columns"];
              this.udcolumns = resp['data']['userdefined_columns'];
              this.rows = result["rows"];
              this.userdefinedparams = new userdefinedParams(this.columns, this.rows, this.udcolumns,
                this.const_statecode_column, this.userdefined_row_code, this.supplemental_row_code, this.const_fixed_columns, this.AssumedFromNonAffiliates_row_code);
              this.userdefinedservice.params = this.userdefinedparams;

              const updatedpremium = this.userdefinedservice.UpdateUDFormulaCells(this.direct_premium, this.supplemental_premium,
                this.userdefined_premium, this.userdefined_premium_supplemental);
              this.direct_premium = updatedpremium[0];
              this.supplemental_premium = updatedpremium[1];
              this.userdefined_premium = updatedpremium[2];
              this.userdefined_premium_supplemental = updatedpremium[3];

              this.hideornot = false;
              this.toastService.show(this.saveResponseMsg, { classname: 'bg-success text-light', delay: 3000 });
              this.unsavedData = false;
              this.getPrgress();
              this.spinnersave = false;
              this.companyService.disableCompanyList.next(false)
              this.companyService.loadPremiumData();
            }
          },
          error: (error) => {
            this.router.navigate(['/apifailure']);
          }
        });
      }
    },
    error: (error) => {
      this.router.navigate(['/apifailure']);
    }
  });
}





  public UpdatePremiumdetails(showmanagecols = false) {
    var griddata = {
      "premreportlobs": this.columns,
      "premreportstates": this.rows,
      "dpremiuminfo": this.direct_premium,
      "spremiuminfo": this.supplemental_premium,
      "udpremiuminfo": this.userdefined_premium,
      "uspremiuminfo": this.userdefined_premium_supplemental,
      "udlobs": this.udcolumns
    };
    this.companyService.disableCompanyList.next(true)
    this.companyService.clearStatus();
    this.companyService.updatepremiumdetails(this.currentYear, this.compno, griddata, this.groupcode, true).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.hideornot = false;
          this.toastService.show(this.saveResponseMsg, { classname: 'bg-success text-light', delay: 3000 });
          this.unsavedData = false;
          this.getPrgress();
          this.companyService.disableCompanyList.next(false);
          this.spinnersave = false;
        }
      },
      error: (error) => {
        //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    });
  }

  getIsoLine(isoline: any) {
    if (typeof isoline === 'object' && isoline.target.value != 0) {
      isoline = isoline.target.value;
      this.selectedisoline = isoline;
      this.unsavedData = true;
      this.pageError = false;
      this.selectedLine = isoline;
    }
    else {
      this.selectedLine = "Select";
    }
  }

  clear() {
    this.companyService.getAnualStatement(this.currentYear, this.compno).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.annualStatement = resp["data"]["mappingdetails"];
          for (var i = 0; i < this.annualStatement.length; i++) {
            this.rowValidateForm(i);
          }
          this.unsavedData = false;
        }
      },
      error: (error) => {
        //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    });

    this.selectedisoline = this.oldselectedisoline;
  }

  openPageChangeModal() {
    const modalRef = this.modalService.open(UnsavedmsgModalComponent);
    modalRef.componentInstance.name = 'New';

    modalRef.result.then((result) => {
      if (result) {
        this.onsubmit();
      }
    });
  }

  removePrevAlerts(){
    for (var i = this.toastService.toasts.length-1; i >= 0; i--) {
      this.toastService.remove(this.toastService.toasts[i]);
    }
  }
}
